
import { Market, Customer } from "../../classes"
import Helper from "../../plugins/Helper/Helper"
import i18n from '@/plugins/vue-i18n';

const MarketModule = {
  namespaced: true,
  state: () => ({
    market: { market: { market: { name: null } } },
    info: {
      count: 0,
      size: 0,
      occupied: 0,
      unpaid: 0,
      vacancy: 0,
    },
    projectId: "",
    currentMarket: null,
    areaViewType: ""
  }),
  actions: {
    getMarketArea: async ({ commit, dispatch }, payload) => {
      try {
        // commit("setMarketNull");
        const data = await Market.getMarketArea({ id: payload.id });
        commit("setMarket", { market: data });
        commit("setProjectId", { projectId: data?.market?.project?.objectId });
        commit("area/setAreas", data.areas, { root: true });
        return data
      } catch (err) {
        throw err
      }
    },
    updateImageBase64: ({ }, payload) => {
      return Market.updateImageBase64(payload);
    },
    updateMarket: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await Market.updateMarket(payload);
        // dispatch("setMarket", { id: rootGetters["markets/getMarketId"] });
        return data;
      } catch (err) {
        return false;
      }
    },
    getMarket: async ({ commit, dispatch, state }, { marketId, force = false }) => {
      try {
        if (state?.currentMarket?.objectId == marketId && !force)
          return state.currentMarket
        else {
          const data = await Market.getMarket(marketId);
          commit("setCurrentMarket", { currentMarket: data });
          return data
        }
      } catch (err) {
        throw err
      }
    },
    getMarketByProject: async ({}, payload) => {
      try  {
        const data = await Market.getMarketByProject(payload);
        return data;
      } catch (err) {
        throw err
      }
    }
  },
  getters: {
    getMarketCount: (state) => state.market?.areas?.length,
    getMarketName: (state) => state.market?.market?.name,
    getProjectId: (state) => state?.projectId,
    getMarketId: (state) => state.market?.market?.objectId,
    getAreas: (state) => state.market?.areas?.map(i => {
      i.productType = i.products && i.products.length ? i.products.map(x => x.name) : '-'
      i.businessName = i.areaBooking ? i.areaBooking.booking.businessName ? i.areaBooking.booking.businessName : "-" : i.contract && i.contract.businessName ? i.contract.businessName : '-';
      i.contractName = i.areaBooking ? i.areaBooking.booking.customer ? Customer.getFullNameByCustomer(i.areaBooking.booking.customer) : "-" : i.contract && i.contract.billingData && i.contract.billingData.name ? i.contract.billingData.name : '-'
      i.isConnected = i?.contract?.customer?.isConnected || false
      i.isConnectedDaily = i?.areaBooking?.areaBooking?.booking?.customer?.isConnected || false
      i.status = i.contract ? i.contract.isEscaped ? 4 : i.contract.isSuspend ? 3 : i.contract.isPaid ? 2 : 1 : 0;
      i.products_label = i.products && i.products.length ? i.products.map(x => x.name).join(" ") : "-"
      i.currentProducts = i.areaBooking ? i.areaBooking.products : i.products && i.products.length ? i.products : [{ name: "-" }]
      i.currentStatus = i.statusText == i18n.t('area.empty_stall') && i.areaBooking && i.areaBooking.type == 'daily' ? [] : [i.statusText]
      i.size = i.size && parseFloat(i.size) > 0 ? Helper.toCurrency(i.size) : parseFloat(i.size).toFixed(2)
      if (i.contract && i.contract.isSuspend && i.currentStatus.length == 0) i.currentStatus.push(i18n.t('suspend.suspend_sale'))
      if (i.areaBooking && i.areaBooking.type == 'daily') i.currentStatus.push(i18n.t('daily'))
      if (i.numOfAreaBooking > 0) i.currentStatus.push(i18n.t('booked'))
      return i
    }),
    getAreaIds: state => state.market?.areas?.map(i => i.objectId),
    getInfo: (state) => state?.info,
    getMarket: (state) => state.market?.market,
    getMarketSetting: (state) => state.market?.market?.setting,
    getMarketEnableRDWebService: (state) => state.currentMarket?.setting?.enableRDWebService == false ? false : true
  },
  mutations: {
    setProjectId: (state, payload) => {
      state.projectId = payload.projectId
    },
    setInfo: (state, payload) => {
      state.info = payload.info
    },
    setMarketNull: (state, payload) => {
      state.market = null;
    },
    setMarket: (state, payload) => {
      state.market = payload.market;
    },
    setCurrentMarket: (state, payload) => {
      state.currentMarket = payload.currentMarket;
    },
    setAreaViewType: (state, payload) => {
      state.areaViewType = payload
    }
  },
};
export default MarketModule;
